class SceneNode {
    constructor() {
        this._enabled = true;
        this._x = 0;
        this._y = 0;
        this._width = 0;
        this._height = 0;
        this._scaleX = 1;
        this._scaleY = 1;
        this._parentSceneGroup = null;
        this._isDirty = false;
        this._debug = SceneNode.debugDefault;
    }
    /*constructor() {
      this._debug = SceneNode.debugDefault;
    }*/
    layout(ctx) {
    }
    render(context2D) {
        if (!this._enabled) {
            return;
        }
        context2D.save();
        context2D.translate(this._x, this._y);
        context2D.scale(this._scaleX, this._scaleY);
        //TODO: Rotate!
        this.onRender(context2D);
        if (this._debug) {
            let oldStrokeStyle = context2D.strokeStyle;
            context2D.strokeStyle = "red";
            context2D.strokeRect(0, 0, this._width, this._height);
            context2D.strokeStyle = oldStrokeStyle;
        }
        context2D.restore();
    }
    onRender(context2D) { }
    set debug(value) {
        this._debug = value;
    }
    get enabled() {
        return this._enabled;
    }
    set enabled(value) {
        if (this._enabled != value) {
            this._enabled = value;
            this.setDirty();
        }
    }
    get x() {
        return this._x;
    }
    set x(value) {
        if (this._x != value) {
            this._x = value;
            this.setDirty();
        }
    }
    get y() {
        return this._y;
    }
    set y(value) {
        if (this._y != value) {
            this._y = value;
            this.setDirty();
        }
    }
    get scaleX() {
        return this._scaleX;
    }
    set scaleX(value) {
        if (this._scaleX != value) {
            this._scaleX = value;
            this.setDirty();
        }
    }
    get scaleY() {
        return this._scaleY;
    }
    set scaleY(value) {
        if (this._scaleY != value) {
            this._scaleY = value;
            this.setDirty();
        }
    }
    get width() {
        return this._width;
    }
    set width(value) {
        if (this._width != value) {
            this._width = value;
            this.setDirty();
        }
    }
    get height() {
        return this._height;
    }
    set height(value) {
        if (this._height != value) {
            this._height = value;
            this.setDirty();
        }
    }
    get parentSceneGroup() {
        return this._parentSceneGroup;
    }
    set parentSceneGroup(value) {
        this._parentSceneGroup = value;
    }
    setDirty() {
        if (!this._isDirty) {
            this._isDirty = true;
            if (this._parentSceneGroup) {
                this._parentSceneGroup.setDirty();
            }
        }
    }
}
SceneNode.debugDefault = false;
class SceneGroup extends SceneNode {
    constructor() {
        super(...arguments);
        this._sceneNodes = new Array();
        ///<-- Child Nodes
    }
    onRender(ctx) {
        for (const sceneNode of this._sceneNodes) {
            sceneNode.render(ctx);
            if (this._debug) {
                ctx.strokeStyle = '#ffffff'; //'#F3CE32';
                ctx.strokeRect(sceneNode.x, sceneNode.y, sceneNode.width, sceneNode.height);
            }
        }
    }
    ///Layout -->
    layout(ctx) {
        if (this._isDirty) {
            this.onDownLayout();
        }
        for (const sceneNode of this._sceneNodes) {
            sceneNode.layout(ctx);
        }
        if (this._isDirty) {
            this.onUpLayout();
            this.calculateSize();
            this._isDirty = false;
        }
    }
    onDownLayout() { }
    onUpLayout() { }
    calculateSize() {
        let width = 0;
        let height = 0;
        for (const sceneNode of this._sceneNodes) {
            const maxX = sceneNode.x + sceneNode.width;
            if (maxX > width) {
                width = maxX;
            }
            const maxY = sceneNode.y + sceneNode.height;
            if (maxY > height) {
                height = maxY;
            }
        }
        this.width = width;
        this.height = height;
    }
    ///<-- Layout
    ///Child Nodes -->
    add(sceneNode) {
        this._sceneNodes.push(sceneNode);
        sceneNode.parentSceneGroup = this;
        this.setDirty();
    }
    remove(sceneNode) {
        let index = this._sceneNodes.indexOf(sceneNode);
        if (index !== -1) {
            sceneNode.parentSceneGroup = null;
            this._sceneNodes.splice(index, 1);
            this.setDirty();
        }
    }
    clear() {
        this._sceneNodes.length = 0;
        this.setDirty();
    }
}
class Scene extends SceneGroup {
    constructor(canvas) {
        super();
        this._canvas = canvas;
    }
    render(ctx) {
        if (this._isDirty) {
            this.layout(ctx);
        }
        ctx.clearRect(0, 0, this._canvas.width, this._canvas.height);
        super.render(ctx);
    }
}
class SceneGraphic extends SceneNode {
    constructor() {
        super(...arguments);
        this._sourceWidth = 0;
        this._sourceHeight = 0;
    }
    get width() {
        return super.width;
    }
    set width(value) {
        this.scaleX = this._sourceWidth ? value / this._sourceWidth : 0;
        super.width = value;
    }
    get height() {
        return super.height;
    }
    set height(value) {
        this.scaleY = this._sourceHeight ? value / this._sourceHeight : 0;
        super.height = value;
    }
}
class SceneImage extends SceneGraphic {
    constructor(source) {
        super();
        this._isLoaded = false;
        this._image = new Image();
        this._image.src = source;
        this._image.onload = () => {
            this._isLoaded = true;
            this._sourceWidth = this._image.naturalWidth;
            this.width = this._width;
            this._sourceHeight = this._image.naturalHeight;
            this.height = this._height;
            this.setDirty();
        };
        this._image.onerror = () => {
            throw new Error("Error loading image: " + source);
        };
    }
    get width() {
        return super.width;
    }
    set width(value) {
        if (this._sourceWidth) {
            this.scaleX = this._sourceWidth ? value / this._sourceWidth : 0;
        }
        super.width = value;
    }
    get height() {
        return super.height;
    }
    set height(value) {
        if (this._sourceHeight) {
            this.scaleY = this._sourceHeight ? value / this._sourceHeight : 0;
        }
        super.height = value;
    }
    onRender(context2D) {
        if (this._isLoaded === true) {
            context2D.drawImage(this._image, 0, 0, this._sourceWidth, this._sourceHeight);
        }
    }
}
class TextSceneNode extends SceneNode {
    //_direction:"ltr" | "rtl" | "inherit" = "inherit"
    constructor(text, fillStyle, font, textAlign = "start", textBaseline = "alphabetic") {
        super();
        this._text = text;
        this._fillStyle = fillStyle;
        this._font = font;
        this._textAlign = textAlign;
        this._textBaseline = textBaseline;
        this.setDirty();
    }
    layout(ctx) {
        if (this._isDirty) {
            this.calculateSize(ctx);
            this._isDirty = false;
        }
    }
    onRender(ctx) {
        this.saveAndSetContext(ctx);
        ctx.fillText(this._text, 0, 0);
        this.restoreContext(ctx);
    }
    setText(text) {
        this._text = text;
        this.setDirty();
    }
    setFillStyle(fillStyle) {
        this._fillStyle = fillStyle;
        this.setDirty();
    }
    setFont(font) {
        this._font = font;
        this.setDirty();
    }
    calculateSize(ctx) {
        this.saveAndSetContext(ctx);
        const textMetrics = ctx.measureText(this._text); // TextMetrics object
        this.width = textMetrics.width;
        this.height = textMetrics.fontBoundingBoxAscent + textMetrics.fontBoundingBoxDescent;
        this.restoreContext(ctx);
    }
    saveAndSetContext(ctx) {
        ctx.save();
        ctx.fillStyle = this._fillStyle;
        ctx.font = this._font;
        ctx.textAlign = this._textAlign;
        ctx.textBaseline = this._textBaseline;
    }
    restoreContext(ctx) {
        ctx.restore();
    }
}
class LineSceneNode extends SceneNode {
    constructor(lineWidth, strokeStyle, startObject, endObject) {
        super();
        this._lineWidth = lineWidth;
        this._strokeStyle = strokeStyle;
        this._startObject = startObject;
        this._endObject = endObject;
        this.setDirty();
    }
    layout(ctx) {
        if (this._isDirty) {
            this.calculateSize(ctx);
            this._isDirty = false;
        }
    }
    onRender(ctx) {
        this.saveAndSetContext(ctx);
        ctx.moveTo(this._startObject.x, this._startObject.y);
        ctx.lineTo(this._endObject.x, this._endObject.y);
        ctx.stroke();
        this.restoreContext(ctx);
    }
    setLineWidth(lineWidth) {
        this._lineWidth = lineWidth;
    }
    setStrokeStyle(strokeStyle) {
        this._strokeStyle = strokeStyle;
    }
    setStartObject(startObject) {
        this._startObject = startObject;
        this.setDirty();
    }
    setEndObject(endObject) {
        this._endObject = endObject;
        this.setDirty();
    }
    calculateSize(ctx) {
        this.saveAndSetContext(ctx);
        this.width = Math.abs(this._startObject.x - this._endObject.x);
        this.height = Math.abs(this._startObject.y - this._endObject.y);
        this.restoreContext(ctx);
    }
    saveAndSetContext(ctx) {
        ctx.save();
        ctx.lineWidth = this._lineWidth;
        ctx.strokeStyle = this._strokeStyle;
    }
    restoreContext(ctx) {
        ctx.restore();
    }
}
class OffsetProxy {
    constructor(sourceObject, deltaX, deltaY) {
        this._sourceObject = sourceObject;
        this._deltaX = deltaX;
        this._deltaY = deltaY;
    }
    get x() {
        return this._sourceObject.x + this._deltaX;
    }
    get y() {
        return this._sourceObject.y + this._deltaY;
    }
}
class FillSceneGraphic extends SceneGraphic {
    constructor(width, height, fillStyle) {
        super();
        this._width = width;
        this._height = height;
        this._fillStyle = fillStyle;
    }
    onRender(context2D) {
        context2D.fillStyle = this._fillStyle;
        context2D.fillRect(0, 0, this._width, this._height);
    }
}
export { Scene, SceneGraphic, SceneGroup, SceneImage, SceneNode, TextSceneNode, LineSceneNode, OffsetProxy, FillSceneGraphic };
